import { useAppConfigContext } from '@vivli/core/infrastructure/context';
import { useDefaultRoutes, useResultRequestRoutes } from '../routes';
import { RouteObject } from 'react-router';
import { useEffect, useState } from 'react';

export const useRoutesInit = (): RouteObject[] => {
    const appConfig = useAppConfigContext();
    const [routes, setRoutes] = useState<RouteObject[]>();

    const defaultRoutes = useDefaultRoutes();
    const resultRequestRoutes = useResultRequestRoutes();

    useEffect(() => {
        const routesToUse = appConfig?.viewRequestResultsOnly ? resultRequestRoutes : defaultRoutes;
        setRoutes(routesToUse);
    }, [appConfig?.viewRequestResultsOnly]);

    return routes;
};
